// The publishable key for cards that pay a venue booking (guest seats, Book a session, race nights).
// Those PaymentIntents are created by the venue WebApi on the bookings Stripe account, while the
// credits checkout (StripeWrapper) pays Identity's intents on the memberships account, and a key
// from the other account fails confirmPayment. Unset, it falls back to the shared key (QA, where the
// Warehouse WebApi and Identity share one test account).
type StripeKeyEnv = Record<string, string | undefined>;

export const bookingPublishableKey = (env: StripeKeyEnv = process.env): string | undefined =>
  env.REACT_APP_STRIPE_BOOKING_PUBLISHABLE_KEY || env.REACT_APP_STRIPE_PUBLISHABLE_KEY;
